import React, { Component } from 'react';

import { withStyles, createStyles, Theme } from '@material-ui/core';

import ResponseError from '../../../models/ResponseError';
import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';
import { connect } from 'react-redux';
import PaymentAudit from './PaymentAudit';
import paymentsRemote from '../../../api/paymentsRemote';
import AlternativePaymentOptions from '../../../models/PaymentOptions';
import ApiResponse from '../../../models/ApiResponse';
import { PaymentAuditModel } from '../../../models/PaymentAudit';
import paymentStyles from '../paymentReportStyles.module.css';
import { PaymentAwbReport } from '../../../models/PaymentReport';
import moment, { Moment } from 'moment';

interface PaymentAuditContainerProps {
  handleClose: (type: string) => void;
  awbNumber: string;
  awbVersion: number;
  receiveSuccess: Function;
  receiveError: Function;
  classes: any;
  paymentId: number;
  changeSettled: () => void;
  payment?: PaymentAwbReport;
  auditModal?: boolean;
  startDate?: Moment;
  endDate?: Moment;
};

interface PaymentAuditContainerState {
  paymentOptions: AlternativePaymentOptions;
  payment: PaymentAuditModel;
  paymentAdjustments: Array<PaymentAuditModel>;
  auditCheckbox: boolean;
  amountCollected: number;
  remarks: string;
};

const INITIAL_PAYMENT_VALUE = {
  reason: '',
  amount: 0,
  source: '',
  pay_date_set: moment().format('YYYYMMDD') 
}

const styles = (theme: Theme) =>

  createStyles({
    formField: {
      height: 40,
      width: '100%'
    },
    rowContainer: {
      paddingRight: 20,
    },
    marginTop10: {
      marginTop: 10
    }
  });

class PaymentAuditContainer extends Component<PaymentAuditContainerProps, PaymentAuditContainerState> {

  state = {
    paymentOptions: {} as AlternativePaymentOptions,
    payment: INITIAL_PAYMENT_VALUE,
    paymentAdjustments: [],
    auditCheckbox: false,
    amountCollected: 0,
    remarks: ''
  }

  componentDidMount() {
    this.getPaymentAdjustments();
    let payment = {...this.state.payment};
    if(this.props.payment) {
      payment.pay_date_set = moment(this.props.payment.payments[0].timestamp).format('YYYYMMDD');
      this.setState({ 
        payment,
        auditCheckbox: this.props.payment.settled, 
        amountCollected: this.props.payment.amount_collected, 
        remarks: this.props.payment.remarks 
      });
    }
      
  }

  changeAudit = () => {
    this.setState({ auditCheckbox: !this.state.auditCheckbox }, () => {
      this.props.changeSettled();
    });
  }

  handleChange = (event: any, type: string) => {
    let paymentObj = { ...this.state.payment };
    let amountCollected = this.state.amountCollected;
    let remarks = this.state.remarks;
    let value = event.target ?  event.target.value : event;
    switch (type) {
      case 'reason': paymentObj.reason = value;
        break;
      case 'amount':
        paymentObj.amount = value;
        break;
      case 'source': paymentObj.source = value;
        break;
      case 'amount_collected': amountCollected = value;
        break;
      case 'remarks': remarks = value;
        break;
      case 'pay_date_set': paymentObj.pay_date_set = moment(value).format('YYYYMMDD');
        break;
      default: break;
    }
  
   
    this.setState({ payment: paymentObj, amountCollected, remarks });
  }

  getPaymentAdjustments = (): void => {
    const code = this.props.awbNumber.split("-")[0];
    const number = this.props.awbNumber.split("-")[1];
    paymentsRemote.getPaymentAdjustments(code, number, this.props.awbVersion, this.props.paymentId, 'audit').then((resp: ApiResponse<Array<PaymentAuditModel>>) => {

      const paymentAdjustments: Array<PaymentAuditModel> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (paymentAdjustments) {
        this.setState({ paymentAdjustments })
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  deletePaymentAdjustment = (id: number): void => {
    const code = this.props.awbNumber.split("-")[0];
    const number = this.props.awbNumber.split("-")[1];
    const startDate: string = this.props.startDate ? this.props.startDate.format('YYYYMMDD') : '';
    const endDate: string = this.props.endDate ? this.props.endDate.format('YYYYMMDD') : '';
    paymentsRemote.deletePaymentAdjustment(code, number, this.props.awbVersion, id, startDate, endDate).then((resp: ApiResponse<number>) => {

      const paymentAdjustments: number | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (paymentAdjustments) {
        this.getPaymentAdjustments();
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  saveAdjustment = (type: string): void => {
    const code = this.props.awbNumber.split("-")[0];
    const number = this.props.awbNumber.split("-")[1];
    const startDate: string = this.props.startDate ? this.props.startDate.format('YYYYMMDD') : '';
    const endDate: string = this.props.endDate ? this.props.endDate.format('YYYYMMDD') : '';
    paymentsRemote.insertPaymentAdjustment(code, number, this.props.awbVersion, this.props.paymentId, this.state.payment, this.state.amountCollected, this.state.remarks, startDate, endDate).then((resp: ApiResponse<any>) => {

      const paymentOptions: any | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      if(paymentOptions) {
        this.getPaymentAdjustments();
        this.setState({ payment: INITIAL_PAYMENT_VALUE });

        if(type === 'submit')
          this.props.handleClose('audit');
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }


  render() {

    return (
        <PaymentAudit
          save={ this.saveAdjustment }
          payment={ this.state.payment }
          handleChange={this.handleChange}
          handleClose={this.props.handleClose}
          awbNumber={this.props.awbNumber}
          paymentAdjustments={ this.state.paymentAdjustments }
          deleteAdjustment={ this.deletePaymentAdjustment }
          changeSettled={ this.changeAudit }
          auditCheck={ this.state.auditCheckbox }
          amountCollected={ this.state.amountCollected }
          remarks={ this.state.remarks }
        />
    )
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (msg: string) => dispatch(receiveSuccess(msg)),
  };
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(PaymentAuditContainer));
